import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import './index.css'
import Chart from "react-apexcharts";
import Image from '../assets/loading1.gif'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const COTLegacy = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [shortdata, setshortdata] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [longdata, setlongdata] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [availableDates, setAvailableDates] = useState([]);
    const [optionosdata, setoptionsdata] = useState([]);

    const apikey = process.env.REACT_APP_API_KEY;
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    `https://financialmodelingprep.com/api/v4/commitment_of_traders_report/${id}?from=2010-09-12&to=2023-07-23&apikey=${apikey}`
                );
                const jsonData = await response.json();
                setData(jsonData);
                setOriginalData(jsonData);
                setoptionsdata(jsonData);
                const datesFromJsonData = jsonData.map((item) => new Date(item.date));
                setAvailableDates(datesFromJsonData);
                const short = [jsonData[0].noncomm_positions_short_all, jsonData[0].comm_positions_short_all, jsonData[0].tot_rept_positions_short_all, jsonData[0].nonrept_positions_short_all];
                setshortdata(short);
                const long = [jsonData[0].noncomm_positions_long_all, jsonData[0].comm_positions_long_all, jsonData[0].tot_rept_positions_long_all, jsonData[0].nonrept_positions_long_all];
                setlongdata(long);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleDateSelect = (date) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const formattedDate = `${year}-${month}-${day}`;
        console.log(formattedDate);
        const filteredData = originalData.filter(item => { // Use originalData for filtering
            const itemDate = item.date.split(' ')[0];
            return itemDate === formattedDate;
        });
        setData(filteredData);
        const short = [
            filteredData[0]?.noncomm_positions_short_all,
            filteredData[0]?.comm_positions_short_all,
            filteredData[0]?.tot_rept_positions_short_all,
            filteredData[0]?.nonrept_positions_short_all,
        ];
        setshortdata(short);
        const long = [
            filteredData[0]?.noncomm_positions_long_all,
            filteredData[0]?.comm_positions_long_all,
            filteredData[0]?.tot_rept_positions_long_all,
            filteredData[0]?.nonrept_positions_long_all,
        ];
        setlongdata(long);
    };

    const formatDateForXAxis = (date) => {
        if (!date) {
            return null;
        }
        const [year, month, day] = date.match(/\d{2}/g);
        if (day !== undefined) {
            const formattedDate = new Date(`20${year}-${month}-${day}`);
            return formattedDate.getTime();
        }
        return null;
    };

    const optionslong = {
        chart: {
            zoom: {
                type: 'x',
                enabled: true,
                autoScaleYaxis: true
            }
        },
        xaxis: {
            type: 'datetime',
            categories: optionosdata.map((item) => formatDateForXAxis(item.as_of_date_in_form_yymmdd)),
        },
    };

    const serieslong = [
        {
            name: "Commercial",
            data: optionosdata.map((item) => item.comm_positions_long_all),
        },
        {
            name: "Non Commercial",
            data: optionosdata.map((item) => item.noncomm_positions_long_all),
        },
        {
            name: "Non Reportable",
            data: optionosdata.map((item) => item.nonrept_positions_long_all),
        },
    ];

    const seriesshort = [
        {
            name: "Commercial",
            data: optionosdata.map((item) => item.comm_positions_short_all),
        },
        {
            name: "Non Commercial",
            data: optionosdata.map((item) => item.noncomm_positions_short_all),
        },
        {
            name: "Non Reportable",
            data: optionosdata.map((item) => item.nonrept_positions_short_all),
        },
    ];

    const optionslongarea = {
        chart: {
            height: 350,
            stacked: true,
            zoom: {
                type: 'x',
                enabled: true,
                autoScaleYaxis: true
            },
            toolbar: {
                show: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
            type: 'datetime',
            categories: optionosdata.map((item) => formatDateForXAxis(item.as_of_date_in_form_yymmdd)),
        },
    };

    return (
        <div className='cotdiv'>
            {data.length > 0 ? (
                <>
                    <div className="cotheader">
                        <h1 className='cotheading'>COT Report :&nbsp;
                            <span style={{ textTransform: "uppercase" }}>
                                {data[0].market_and_exchange_names}
                            </span>
                        </h1>
                        <h3 className='cotsubheading'>Futures Only Positions as of  {data.length > 0 ? data[0].date.split(' ')[0] : 'Loading...'}</h3>
                        <p className='cotcontent'>Below is the Commitments of Traders (COT) report for {data[0].short_name} (futures only) with COT charts. This COT report for AUSTRALIAN DOLLAR is as of {data.length > 0 ? data[0].date.split(' ')[0] : 'Loading...'}. COT reports are released each Friday (except for U.S. holidays) by the CFTC. Each COT report release includes data from the previous Tuesday.</p>
                    </div>
                    <div className="row flex-sm-row flex-column" style={{ marginBottom: "30px" }}>
                        <div className="col col-sm-8">
                            <strong>{data[0].market_and_exchange_names}</strong> (CONTRACTS OF AUD 100,000)<br />
                            <strong>FUTURES ONLY POSITIONS</strong><br />
                            <strong>CFTC Code : </strong>#{data[0].cftc_contract_market_code}<br />
                        </div>
                        <div className="col col-sm-4 text-right mt-sm-0 mt-3">
                            <div className="mb-2"><strong>AS OF : </strong>
                                {selectedDate ? selectedDate.toLocaleDateString() : (data.length > 0 ? data[0].date.split(' ')[0] : 'Loading...')}
                            </div>
                            <div className='calendarbtn'>
                                <DatePicker onChange={handleDateSelect} className='past-data-datepicker btn green-btn btn-sm' placeholderText='View Historical Date' includeDates={availableDates}>
                                </DatePicker>
                                <i className="fa fa-calendar-plus-o calendar-icon" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th colSpan="3" className="text-center">Non-Commercial</th>
                                    <th colSpan="2" className="text-center">Commercial</th>
                                    <th colSpan="2" className="text-center">Total</th>
                                    <th colSpan="2" className="text-center">Non-Reportable</th>
                                </tr>
                                <tr>
                                    <th className="text-center">Long</th>
                                    <th className="text-center">Short</th>
                                    <th className="text-center">Spreads</th>
                                    <th className="text-center">Long</th>
                                    <th className="text-center">Short</th>
                                    <th className="text-center">Long</th>
                                    <th className="text-center">Short</th>
                                    <th className="text-center">Long</th>
                                    <th className="text-center">Short</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan="5" className="text-left">(CONTRACTS OF AUD 100,000)</td>
                                    <td colSpan="4" className="text-right">Open Interest: <span className="number">{data[0].open_interest_all}</span></td>
                                </tr>
                                <tr>
                                    <td className="number">{data[0].noncomm_positions_long_all}</td>
                                    <td className="number">{data[0].noncomm_positions_short_all}</td>
                                    <td className="number">{data[0].noncomm_postions_spread_all}</td>
                                    <td className="number">{data[0].comm_positions_long_all}</td>
                                    <td className="number">{data[0].comm_positions_short_all}</td>
                                    <td className="number">{data[0].tot_rept_positions_long_all}</td>
                                    <td className="number">{data[0].tot_rept_positions_short_all}</td>
                                    <td className="number">{data[0].nonrept_positions_long_all}</td>
                                    <td className="number">{data[0].nonrept_positions_short_all}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5" className="text-left">Changes</td>
                                    <td colSpan="4" className="text-right">(Change In Open Interest: <span className="number"><span className={`${data[0].change_in_open_interest_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_open_interest_all}</span></span> )</td>
                                </tr>
                                <tr>
                                    <td><span className={`${data[0].change_in_noncomm_long_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_noncomm_long_all}</span></td>
                                    <td><span className={`${data[0].change_in_noncomm_short_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_noncomm_short_all}</span></td>
                                    <td><span className={`${data[0].change_in_noncomm_spead_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_noncomm_spead_all}</span></td>
                                    <td><span className={`${data[0].change_in_comm_long_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_comm_long_all}</span></td>
                                    <td><span className={`${data[0].change_in_comm_short_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_comm_short_all}</span></td>
                                    <td><span className={`${data[0].change_in_tot_rept_long_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_tot_rept_long_all}</span></td>
                                    <td><span className={`${data[0].change_in_tot_rept_short_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_tot_rept_short_all}</span></td>
                                    <td><span className={`${data[0].change_in_nonrept_long_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_nonrept_long_all}</span></td>
                                    <td><span className={`${data[0].change_in_nonrept_short_all < 0 ? 'negative' : 'positive'}`}>{data[0].change_in_nonrept_short_all}</span></td>
                                </tr>
                                <tr>
                                    <td colSpan="9" className="text-left">Percent of Open Interest for Each Category of Traders</td>
                                </tr>
                                <tr>
                                    <td className="number">{data[0].pct_of_oi_noncomm_long_all}</td>
                                    <td className="number">{data[0].pct_of_oi_noncomm_short_all}</td>
                                    <td className="number">{data[0].pct_of_oi_noncomm_spread_all}</td>
                                    <td className="number">{data[0].pct_of_oi_comm_long_all}</td>
                                    <td className="number">{data[0].pct_of_oi_comm_short_all}</td>
                                    <td className="number">{data[0].pct_of_oi_tot_rept_long_all}</td>
                                    <td className="number">{data[0].pct_of_oi_tot_rept_short_all}</td>
                                    <td className="number">{data[0].pct_of_oi_nonrept_long_all}</td>
                                    <td className="number">{data[0].pct_of_oi_nonrept_short_all}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5" className="text-left">Number of Traders in Each Category
                                    </td>
                                    <td colSpan="4" className="text-right">(Total Traders: <span className="number">{data[0].traders_tot_all}</span>)</td>
                                </tr>
                                <tr>
                                    <td className="number">{data[0].traders_noncomm_long_all}</td>
                                    <td className="number">{data[0].traders_noncomm_short_all}</td>
                                    <td className="number">{data[0].traders_noncomm_spread_all}</td>
                                    <td className="number">{data[0].traders_comm_long_all}</td>
                                    <td className="number">{data[0].traders_comm_short_all}</td>
                                    <td className="number">{data[0].traders_tot_rept_long_all}</td>
                                    <td className="number">{data[0].traders_tot_rept_short_all}</td>
                                    <td className="number">{data[0].traders_nonrept_long_all}</td>
                                    <td className="number">{data[0].traders_nonrept_short_all}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="charts" style={{ marginTop: "4rem" }}>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    stacked: true,
                                    stackType: '100%',
                                    toolbar: {
                                        show: false
                                    }
                                },
                                grid: {
                                    show: false,
                                },
                                yaxis: {
                                    show: false,
                                },
                                responsive: [{
                                    breakpoint: 480,
                                    options: {
                                        legend: {
                                            position: 'bottom',
                                            offsetX: -10,
                                            offsetY: 0
                                        }
                                    }
                                }],
                                xaxis: {
                                    categories: ['Non Commercial', 'Commercial', 'Total Rept', 'Non Rept']
                                },
                                fill: {
                                    opacity: 1,
                                    colors: ['#7fcea5', '#d56a72']
                                },
                                legend: {
                                    position: 'right',
                                    offsetX: 0,
                                    offsetY: 50,
                                    markers: {
                                        fillColors: ['#7fcea5', '#d56a72'],
                                    }
                                }
                            }}
                            series={
                                [
                                    {
                                        name: 'LONG',
                                        data: longdata
                                    },
                                    {
                                        name: 'SHORT',
                                        data: shortdata
                                    }
                                ]}
                            type="bar"
                            height={350}
                        />
                        <div style={{ marginTop: "4rem" }}>
                            <h1>Price And Net Positions</h1>
                            <div id="chart-candlestick" style={{ marginBottom: "5rem" }}>
                                <Chart
                                    options={{
                                        chart: {
                                            type: 'candlestick',
                                            height: 290,
                                            id: 'candles',
                                            toolbar: {
                                                autoSelected: 'pan',
                                                show: false,
                                            },
                                            zoom: {
                                                enabled: false,
                                            },
                                        },
                                        plotOptions: {
                                            candlestick: {
                                                colors: {
                                                    upward: '#7fcea5',
                                                    downward: '#DF7D46',
                                                },
                                            },
                                        },
                                        xaxis: {
                                            type: 'datetime',
                                        },
                                    }}
                                    series={[{
                                        data: [{
                                            x: new Date(1538778600000),
                                            y: [6629.81, 6650.5, 6623.04, 6633.33]
                                        },
                                        {
                                            x: new Date(1538780400000),
                                            y: [6632.01, 6643.59, 6620, 6630.11]
                                        },
                                        {
                                            x: new Date(1538782200000),
                                            y: [6630.71, 6648.95, 6623.34, 6635.65]
                                        },
                                        {
                                            x: new Date(1538784000000),
                                            y: [6635.65, 6651, 6629.67, 6638.24]
                                        },
                                        {
                                            x: new Date(1538785800000),
                                            y: [6638.24, 6640, 6620, 6624.47]
                                        },
                                        {
                                            x: new Date(1538787600000),
                                            y: [6624.53, 6636.03, 6621.68, 6624.31]
                                        },
                                        {
                                            x: new Date(1538789400000),
                                            y: [6624.61, 6632.2, 6617, 6626.02]
                                        },
                                        {
                                            x: new Date(1538791200000),
                                            y: [6627, 6627.62, 6584.22, 6603.02]
                                        },
                                        {
                                            x: new Date(1538793000000),
                                            y: [6605, 6608.03, 6598.95, 6604.01]
                                        },
                                        {
                                            x: new Date(1538794800000),
                                            y: [6604.5, 6614.4, 6602.26, 6608.02]
                                        },
                                        {
                                            x: new Date(1538796600000),
                                            y: [6608.02, 6610.68, 6601.99, 6608.91]
                                        },
                                        {
                                            x: new Date(1538798400000),
                                            y: [6608.91, 6618.99, 6608.01, 6612]
                                        },
                                        {
                                            x: new Date(1538800200000),
                                            y: [6612, 6615.13, 6605.09, 6612]
                                        },
                                        {
                                            x: new Date(1538802000000),
                                            y: [6612, 6624.12, 6608.43, 6622.95]
                                        },
                                        {
                                            x: new Date(1538803800000),
                                            y: [6623.91, 6623.91, 6615, 6615.67]
                                        },
                                        {
                                            x: new Date(1538805600000),
                                            y: [6618.69, 6618.74, 6610, 6610.4]
                                        },
                                        {
                                            x: new Date(1538807400000),
                                            y: [6611, 6622.78, 6610.4, 6614.9]
                                        },
                                        {
                                            x: new Date(1538809200000),
                                            y: [6614.9, 6626.2, 6613.33, 6623.45]
                                        },
                                        {
                                            x: new Date(1538811000000),
                                            y: [6623.48, 6627, 6618.38, 6620.35]
                                        },
                                        {
                                            x: new Date(1538812800000),
                                            y: [6619.43, 6620.35, 6610.05, 6615.53]
                                        },
                                        {
                                            x: new Date(1538814600000),
                                            y: [6615.53, 6617.93, 6610, 6615.19]
                                        },
                                        {
                                            x: new Date(1538816400000),
                                            y: [6615.19, 6621.6, 6608.2, 6620]
                                        },
                                        {
                                            x: new Date(1538818200000),
                                            y: [6619.54, 6625.17, 6614.15, 6620]
                                        },
                                        {
                                            x: new Date(1538820000000),
                                            y: [6620.33, 6634.15, 6617.24, 6624.61]
                                        },
                                        {
                                            x: new Date(1538821800000),
                                            y: [6625.95, 6626, 6611.66, 6617.58]
                                        },
                                        {
                                            x: new Date(1538823600000),
                                            y: [6619, 6625.97, 6595.27, 6598.86]
                                        },
                                        {
                                            x: new Date(1538825400000),
                                            y: [6598.86, 6598.88, 6570, 6587.16]
                                        },
                                        {
                                            x: new Date(1538827200000),
                                            y: [6588.86, 6600, 6580, 6593.4]
                                        },
                                        {
                                            x: new Date(1538829000000),
                                            y: [6593.99, 6598.89, 6585, 6587.81]
                                        },
                                        {
                                            x: new Date(1538830800000),
                                            y: [6587.81, 6592.73, 6567.14, 6578]
                                        },
                                        {
                                            x: new Date(1538832600000),
                                            y: [6578.35, 6581.72, 6567.39, 6579]
                                        },
                                        {
                                            x: new Date(1538834400000),
                                            y: [6579.38, 6580.92, 6566.77, 6575.96]
                                        },
                                        {
                                            x: new Date(1538836200000),
                                            y: [6575.96, 6589, 6571.77, 6588.92]
                                        },
                                        {
                                            x: new Date(1538838000000),
                                            y: [6588.92, 6594, 6577.55, 6589.22]
                                        },
                                        {
                                            x: new Date(1538839800000),
                                            y: [6589.3, 6598.89, 6589.1, 6596.08]
                                        },
                                        {
                                            x: new Date(1538841600000),
                                            y: [6597.5, 6600, 6588.39, 6596.25]
                                        },
                                        {
                                            x: new Date(1538843400000),
                                            y: [6598.03, 6600, 6588.73, 6595.97]
                                        },
                                        {
                                            x: new Date(1538845200000),
                                            y: [6595.97, 6602.01, 6588.17, 6602]
                                        },
                                        {
                                            x: new Date(1538847000000),
                                            y: [6602, 6607, 6596.51, 6599.95]
                                        },
                                        {
                                            x: new Date(1538848800000),
                                            y: [6600.63, 6601.21, 6590.39, 6591.02]
                                        },
                                        {
                                            x: new Date(1538850600000),
                                            y: [6591.02, 6603.08, 6591, 6591]
                                        },
                                        {
                                            x: new Date(1538852400000),
                                            y: [6591, 6601.32, 6585, 6592]
                                        },
                                        {
                                            x: new Date(1538854200000),
                                            y: [6593.13, 6596.01, 6590, 6593.34]
                                        },
                                        {
                                            x: new Date(1538856000000),
                                            y: [6593.34, 6604.76, 6582.63, 6593.86]
                                        },
                                        {
                                            x: new Date(1538857800000),
                                            y: [6593.86, 6604.28, 6586.57, 6600.01]
                                        },
                                        {
                                            x: new Date(1538859600000),
                                            y: [6601.81, 6603.21, 6592.78, 6596.25]
                                        },
                                        {
                                            x: new Date(1538861400000),
                                            y: [6596.25, 6604.2, 6590, 6602.99]
                                        },
                                        {
                                            x: new Date(1538863200000),
                                            y: [6602.99, 6606, 6584.99, 6587.81]
                                        },
                                        {
                                            x: new Date(1538865000000),
                                            y: [6587.81, 6595, 6583.27, 6591.96]
                                        },
                                        {
                                            x: new Date(1538866800000),
                                            y: [6591.97, 6596.07, 6585, 6588.39]
                                        },
                                        {
                                            x: new Date(1538868600000),
                                            y: [6587.6, 6598.21, 6587.6, 6594.27]
                                        },
                                        {
                                            x: new Date(1538870400000),
                                            y: [6596.44, 6601, 6590, 6596.55]
                                        },
                                        {
                                            x: new Date(1538872200000),
                                            y: [6598.91, 6605, 6596.61, 6600.02]
                                        },
                                        {
                                            x: new Date(1538874000000),
                                            y: [6600.55, 6605, 6589.14, 6593.01]
                                        },
                                        {
                                            x: new Date(1538875800000),
                                            y: [6593.15, 6605, 6592, 6603.06]
                                        },
                                        {
                                            x: new Date(1538877600000),
                                            y: [6603.07, 6604.5, 6599.09, 6603.89]
                                        },
                                        {
                                            x: new Date(1538879400000),
                                            y: [6604.44, 6604.44, 6600, 6603.5]
                                        },
                                        {
                                            x: new Date(1538881200000),
                                            y: [6603.5, 6603.99, 6597.5, 6603.86]
                                        },
                                        {
                                            x: new Date(1538883000000),
                                            y: [6603.85, 6605, 6600, 6604.07]
                                        },
                                        {
                                            x: new Date(1538884800000),
                                            y: [6604.98, 6606, 6604.07, 6606]
                                        }]
                                    }]}
                                    type="candlestick"
                                    height={290}
                                />
                            </div>
                            <h1>Positions Long</h1>
                            <div id="chart-line" style={{ marginBottom: "5rem" }}>
                                <Chart options={optionslong} series={serieslong} type="line" height={350} />;
                            </div>
                            <div id="chart-area" style={{ marginBottom: "5rem" }}>
                                <Chart options={optionslongarea} series={serieslong} type="area" height={350} />;
                            </div>
                            <h1>Positions Short</h1>
                            <div id="chart-line" style={{ marginBottom: "5rem" }}>
                                <Chart options={optionslong} series={seriesshort} type="line" height={350} />;
                            </div>
                            <div id="chart-area" style={{ marginBottom: "5rem" }}>
                                <Chart options={optionslongarea} series={seriesshort} type="area" height={350} />;
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <p className='text-center'><img src={Image} alt="Loading......." /></p>
            )}
        </div>
    );
}

export default COTLegacy